import React from 'react';
import { Truck, Anchor, Link, Move, ArrowUp, Zap, Disc, Drill, Ruler, Package } from 'lucide-react';
import { equipment } from '../mock';
import { Card, CardContent } from './ui/card';

const iconMap = {
  Truck: Truck,
  Anchor: Anchor,
  Link: Link,
  Move: Move,
  ArrowUp: ArrowUp,
  Zap: Zap,
  Disc: Disc,
  Drill: Drill,
  Ruler: Ruler,
  Package: Package
};

const EquipmentSection = () => {
  return (
    <section id="equipment" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            Our <span className="text-blue-600">Equipment</span>
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            State-of-the-art machinery and tools for comprehensive power plant operations
          </p>
        </div>

        {/* Equipment Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {equipment.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <Card
                key={index}
                className="group hover:shadow-lg transition-all duration-300 border-2 hover:border-blue-600"
              >
                <CardContent className="p-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-blue-600 transition-colors duration-300">
                      <Icon className="w-6 h-6 text-blue-600 group-hover:text-white transition-colors duration-300" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-sm font-semibold text-slate-800 mb-2 group-hover:text-blue-600 transition-colors">
                        {item.name}
                      </h3>
                      <div className="flex items-center">
                        <span className="text-2xl font-bold text-blue-600">{item.quantity}</span>
                        <span className="text-sm text-slate-500 ml-2">Units</span>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Equipment Highlights */}
        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="bg-slate-50 rounded-xl p-8 text-center border-2 border-slate-200">
            <div className="text-4xl font-bold text-blue-600 mb-2">1,500+</div>
            <p className="text-slate-600 font-medium">Total Equipment Units</p>
            <p className="text-sm text-slate-500 mt-2">Comprehensive inventory for all project needs</p>
          </div>
          <div className="bg-slate-50 rounded-xl p-8 text-center border-2 border-slate-200">
            <div className="text-4xl font-bold text-blue-600 mb-2">300+</div>
            <p className="text-slate-600 font-medium">Welding Equipment</p>
            <p className="text-sm text-slate-500 mt-2">Rectifiers and transformers for all welding needs</p>
          </div>
          <div className="bg-slate-50 rounded-xl p-8 text-center border-2 border-slate-200">
            <div className="text-4xl font-bold text-blue-600 mb-2">500+</div>
            <p className="text-slate-600 font-medium">Chain Pulley Blocks</p>
            <p className="text-sm text-slate-500 mt-2">Heavy-duty material handling equipment</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EquipmentSection;
